/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Segment_PrefixInputs */

const en_segment_event_group_segment_prefix = /** @type {(inputs: Segment_Event_Group_Segment_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment`)
};

const fr_segment_event_group_segment_prefix = /** @type {(inputs: Segment_Event_Group_Segment_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment`)
};

const de_segment_event_group_segment_prefix = /** @type {(inputs: Segment_Event_Group_Segment_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment`)
};

const it_segment_event_group_segment_prefix = /** @type {(inputs: Segment_Event_Group_Segment_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmento`)
};

const ru_segment_event_group_segment_prefix = /** @type {(inputs: Segment_Event_Group_Segment_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сегмент`)
};

const es_segment_event_group_segment_prefix = /** @type {(inputs: Segment_Event_Group_Segment_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmento`)
};

const zh_cn2_segment_event_group_segment_prefix = /** @type {(inputs: Segment_Event_Group_Segment_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部分`)
};

const ja_segment_event_group_segment_prefix = /** @type {(inputs: Segment_Event_Group_Segment_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セグメント`)
};

const hi_segment_event_group_segment_prefix = /** @type {(inputs: Segment_Event_Group_Segment_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खंड`)
};

const pt_pt2_segment_event_group_segment_prefix = /** @type {(inputs: Segment_Event_Group_Segment_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmento`)
};

/**
* | output |
* | --- |
* | "Segment" |
*
* @param {Segment_Event_Group_Segment_PrefixInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_segment_prefix = /** @type {((inputs?: Segment_Event_Group_Segment_PrefixInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Segment_PrefixInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_segment_prefix(inputs)
	if (locale === "de") return de_segment_event_group_segment_prefix(inputs)
	if (locale === "it") return it_segment_event_group_segment_prefix(inputs)
	if (locale === "ru") return ru_segment_event_group_segment_prefix(inputs)
	if (locale === "es") return es_segment_event_group_segment_prefix(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_segment_prefix(inputs)
	if (locale === "ja") return ja_segment_event_group_segment_prefix(inputs)
	if (locale === "hi") return hi_segment_event_group_segment_prefix(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_segment_prefix(inputs)
	return en_segment_event_group_segment_prefix(inputs)
});